import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Selector from 'components/Selector'
import Item from './Item'
import {palette} from 'utils/enums/colors'

const FilterList = styled.div`
    margin-bottom: 20px;
`

const Empty = styled.div`
    height: 70px;
    align-items: center;
    padding: 0 20px;
    display: flex;
    border: none;
    margin: 0;
    box-shadow: 0 1px 3px 0 rgba(179, 216, 225, .5);
    background: #FFF;
`

class PlanningColors extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            colors: [ ...props.data ]
        }

    }

    handleSelect = (data) => {
        const colors = [...this.state.colors]
        colors.push({ value: data.value, fieldId: data.fieldId, color: palette[colors.length] })

        this.setState({
            colors
        })
    }

    handleChange = (value, color) => {
        const colors = [...this.state.colors]
        const item = {...colors.find(item => item.value === value)}
        const index = colors.findIndex(item => item.value === value)

        item.color = color

        colors.splice(index, 1, item)

        this.setState({
            colors
        })
    }

    handleDelete = (value) => {
        const colors = [...this.state.colors.filter(item => item.value !== value)]
        this.setState({ colors })
    }

    setColors = () => {
        const data = this.state.colors.map(item => {
            return {
                fieldId: item.fieldId,
                value: item.value,
                color: item.color
            }
        })

        this.props.setColors(this.props.planning, data)
        this.props.handleClose()
    }

    render() {
        const { intl } = this.props
        const items = this.state.colors.filter(item =>
            this.props.colors.find(color => item.value === color.value))

        return (
            <React.Fragment>
                <DialogTitle>
					{intl.formatMessage({id: "planning.colors_assignment"})}
                </DialogTitle>
                <DialogContent>
                    <FilterList>
                    {!items.length &&
                        <Empty>{intl.formatMessage({id: "planning.colors_empty"})}</Empty>
                    }
                    {items.map((item, index) =>
                        <Item
                            key={index}
                            title={this.props.colors.find(color => item.value === color.value).name}
                            color={item.color}
                            fieldId={item.fieldId}
                            value={item.value}
                            handleChange={this.handleChange}
                            handleDelete={this.handleDelete}
                        />
                    )}
                    </FilterList>
                    <Selector
                        data={this.props.colors.filter(el =>
                            !items.find(color => color.value === el.value)).map(item => {
                                return {
                                    name: item.name,
                                    ...item
                                }
                            }
                        )}
                        disabled={items.length === this.props.colors.length}
                        handleSelect={this.handleSelect}
                        text='planning.add_color'
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    <Button variant="contained"
                        onClick={this.setColors}
                        color="primary"
                    >
                        {intl.formatMessage({id: "app.confirm_save"})}
                    </Button>
                </DialogActions>
            </React.Fragment>
        )
    }
}

export default injectIntl(PlanningColors)
